import { ScreenHeader } from '@/components/layout/screen-header';
import { Text } from '@/components/ui/text';
import React from 'react';
import { Pressable } from 'react-native';

interface NotificationsHeaderProps {
  unreadCount: number;
  onMarkAllAsRead?: () => void;
}

export function NotificationsHeader({
  unreadCount,
  onMarkAllAsRead,
}: NotificationsHeaderProps) {
  const subtitle =
    unreadCount > 0
      ? `You have ${unreadCount} unread notification${unreadCount > 1 ? 's' : ''}`
      : undefined;

  const rightSlot =
    unreadCount > 0 ? (
      <Pressable onPress={onMarkAllAsRead}>
        <Text className="font-medium text-primary text-sm">
          Mark all as read
        </Text>
      </Pressable>
    ) : undefined;

  return (
    <ScreenHeader
      title="Notifications"
      subtitle={subtitle}
      rightSlot={rightSlot}
      showMenuButton
    />
  );
}
